import { AttributeBaseModel } from './AttributeBaseModel';
import { AttributeUsageModel } from './AttributeUsageModel';
export class BufferAttributeModel extends AttributeBaseModel {
    constructor({ usage, value }) {
        super();
        this.usage = usage;
        this.value = value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        if (this.usage === AttributeUsageModel.DescriptionUrl) {
            writer.writeUInt8(this.value.length);
            writer.writeBytes(this.value);
        }
        else {
            writer.writeVarBytesLE(this.value);
        }
    }
}

//# sourceMappingURL=BufferAttributeModel.js.map
